export default class TestimonialsGrid {

    constructor() {
        this.addEvents();
    }
    addEvents() {
        jQuery(document).ready(function($) {
            let paged = 1;
            let ajaxurl = '/wp-admin/admin-ajax.php';
            let debounceTimer;
            let current_page_id = $('section.testimonials-posts').data('pageid')
            let loading = "<div class='testimonials-loading'><span class='testimonials-loading__text'>Loading...</span><div class='testimonials-loading__ball'></div></div>"
            let shouldScrollToTestimonials = false;

            function loadTestimonials() {

                $('.testimonials-posts__container').html(loading)

                if (shouldScrollToTestimonials) {
                    const testimonial_parent = document.querySelector(".testimonials-posts");

                    if (testimonial_parent) {
                        const y = testimonial_parent.getBoundingClientRect().top + window.pageYOffset - 300;
                        window.scrollTo({ top: y});
                        history.replaceState(null, null, "#testimonial-post");
                    }

                    shouldScrollToTestimonials = false;
                }

                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'load_testimonials',
                        paged: paged,
                        pageID: current_page_id
                    },
                    success: function(response) {
                        $('.testimonials-posts__container').html(response);
                    },
                });
            }

            $(document).on('click', '.pagination-link:not(.disabled)', function(e) {
                e.preventDefault();
                shouldScrollToTestimonials = true;
                paged = $(this).data('page');
                loadTestimonials();
            });

            loadTestimonials();
        });
    }

}
